<angular-image-viewer [src]="arImages" [config]="objConfig"></angular-image-viewer>
